/** Legacy localStorage key; only read once to migrate users onto `VAT_COOKIE`. */
export const VAT_STORAGE_KEY = 'wwe-show-vat';
/** Set to "true" while prices show inc VAT. A cookie so SSR renders the same prices the browser hydrates with. */
export const VAT_COOKIE = 'wwe-show-vat';
export function isVatCookieValue(value: unknown): boolean {
    return value === 'true' || value === true;
}
export const DEFAULT_CURRENCY = 'GBP';
export const DEFAULT_SYMBOL = '£';
